export function EndMessage() {
  return (
    <footer className="mt-16 py-6 w-full text-center border-t border-gray-300 text-gray-500">
      <p>&copy; 2024 Pratiyank Kumar | Built with ❤️ and React</p>
    </footer>
  );
}
